module.exports = __webpack_public_path__ + "defaultImg.eca0836b.png";